/**!
 * Created by Leonardo Cheslacki on 15/08/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import StageController from './StageController';

import config from '../../../../config';

const {default: {api}} = config;

import WithType from './../helpers/WithType';

let _this = {};

/**
 *
 */
class StageQuiz extends StageController {

    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main = {}) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {
            data: {
                name: null,
                email: null,
                cell: null,
                position_id: null,
                employee_id: null,
                sector_id: null,
                challenge_id: null
            },
            next: false
        };

        this.$inputs = {};

        this.$current_frame = 1;

        this.$supportKeyboard = null;

        this.$supportSelect = null;

        _this = this;
    };

    $functions = {
        /**
         *
         */
        handleStart: function () {
            _this.throttle('handleStart', () => {
                _this.setState({..._this.state, next: false}, () => {
                    const {occ_disclaimer, btn_start} = _this.getFrame();

                    btn_start.visible = false;
                    occ_disclaimer.gotoAndPlay('start');
                });
            }, 100);
        },

        /**
         *
         */
        handleClose: function () {
            _this.throttle('handleClose', () => {
                _this.setState({..._this.state, next: false}, () => {
                    const {occ_disclaimer, btn_start} = _this.getFrame();

                    btn_start.visible = true;
                    occ_disclaimer.gotoAndPlay('continue');
                });
            }, 100);
        },

        /**
         *
         */
        handleNext: function () {
            _this.throttle('handleNext', () => {
                const
                    _this_frame = _this.getFrame(),
                    occ_disclaimer = _this.verifyField(_this_frame, 'occ_disclaimer');

                _this.setState({..._this.state, next: true}, () => {
                    if (occ_disclaimer) {
                        const {btn_start} = _this_frame;

                        btn_start.visible = true;
                        occ_disclaimer.gotoAndPlay('continue');
                    } else {
                        const
                            {data} = _this.state,
                            occ = _this.padWithLeadingZeros(_this.$current_frame, 2);

                        _this.postForm(`${api.url}/quiz-validate-${occ}`, {quiz: data}, {
                            done: ({status, errors}) => {
                                if (Boolean(status)) {
                                    _this.$supportKeyboard.clearErrors();
                                    _this_frame.gotoAndPlay('continue');
                                } else {
                                    const {quiz} = errors;
                                    _this.$supportKeyboard.getErrors(quiz);
                                }
                            },
                            fail: (response) => {
                                console.log(response);
                            },
                            always: () => {

                            }
                        });
                    }
                });
            }, 100);
        },

        /**
         *
         */
        handleSubmit: function () {
            _this.throttle('handleSubmit', () => {
                const {data} = _this.state;

                _this.postForm(`${api.url}/quiz`, {quiz: data}, {
                    done: ({status, errors}) => {
                        if (Boolean(status)) {
                            _this.$supportKeyboard.clearErrors();
                            _this.setState({..._this.state, next: true}, () => {
                                _this.getFrame().gotoAndPlay('continue');
                            });
                        } else {
                            console.log(errors);
                        }
                    },
                    fail: (response) => {
                        console.log(response);
                    },
                    always: () => {

                    }
                });
            }, 100);
        },

        handleBack: function () {
            _this.setState({..._this.state, next: false, data: {}}, () => {
                _this.getFrame().gotoAndPlay('continue');
            });
        },

        /**
         *
         * @param event
         * @param radio
         */
        handleRadio: function (event, {radio}) {
            _this.throttle('handleRadio', () => {
                const {occ_form: {children}} = _this.getFrame();

                children.find((property) => {
                    let {occ_radio, state: {value, name}} = property;

                    if (value.toString() === radio.state.value.toString()) {
                        occ_radio.gotoAndStop('enabled');
                        _this.setStates({data: {[name]: value}});
                    } else {
                        occ_radio.gotoAndStop('disabled');
                    }
                });
            }, 100);
        }
    };

    startQuiz = () => {
        const
            {profile_ukg, profile_hcm, option_position} = this.props,
            {totalFrames} = this.get();

        let total_frames = (totalFrames - 1);

        /**
         * On of emit current_name index, correspond all animate_end.
         */
        this.main.on('animate_end', ({current_name}) => {
            const {data, next} = this.state;

            if (next) {
                this.$current_frame++;
            } else if (this.$current_frame >= total_frames) {
                this.$current_frame = 1;
            }

            this.gotoAndStopFrame(this.get(), this.$current_frame);

            const _this_frame = this.getFrame();

            if (next || current_name === 'submit') {
                _this_frame.gotoAndPlay('start');
            }

            if (next) {
                if (this.$current_frame < total_frames) {
                    const
                        {btn_next} = _this_frame,
                        occ = this.padWithLeadingZeros(this.$current_frame, 2);

                    if (occ === '02') {
                        const {quiz_position, quiz_position: {occ_option}} = _this_frame;

                        if (this.$supportKeyboard) {
                            this.$supportKeyboard.defineKeyboard();
                        } else {
                            this.$supportKeyboard = this.main.$supportKeyboard({
                                _this_class: this,
                                _this_layer: _this_frame,
                                _btn_submit: btn_next,
                                form: 'quiz',
                                focus: 'quiz_name'
                            });

                            this.$supportKeyboard.initKeyboard();
                        }

                        if (this.$supportSelect) {
                            this.$supportSelect.defineSelect();
                        } else {
                            this.$supportSelect = this.main.$supportSelect({
                                _this_class: this,
                                _this_layer: _this_frame,
                                _select: quiz_position,
                                _option: occ_option,
                                form: 'quiz',
                                data: option_position,
                                clearErrors: this.$supportKeyboard.clearErrors
                            });

                            this.$supportSelect.initSelect();
                        }
                    }

                    if (this.inArray(['03', '04', '05'], occ)) {
                        const
                            {occ_form: {children}, occ_error} = _this_frame,
                            length = children.length;

                        for (let i = 0; i < length; i++) {
                            let
                                property = children[i],
                                form = 'quiz',
                                name = `${this.toName(property.name.replace(`${form}_`, ''))}_id`,
                                number = this.toNumber(property.name),
                                index = this.padWithLeadingZeros(number, 2);

                            property.occ_radio.gotoAndStop('disabled');

                            _this.setStates({data: {[name]: null}});

                            this[`_handleRadio${index}`] && property.off('mousedown', this[`_handleRadio${index}`]);
                            this[`_handleRadio${index}`] = property.on('mousedown', this.$functions.handleRadio, false, false, {
                                index: index,
                                form: 'quiz',
                                radio: property
                            });

                            this.setStateOccurrence(property, {
                                name: name,
                                type: 'radio',
                                focus: false,
                                value_x: null,
                                caret_x: null,
                                line_width: null,
                                placeholder: null,
                                tab_index: null,
                                value: number,
                                mask: ''
                            });

                            if (this.endFor(length, i)) {
                                this.$inputs[name] = {occ_error: occ_error};
                            }
                        }
                    }

                    if (this.inArray(['02', '03', '04', '05'], occ)) {
                        this[`_handleNext${occ}`] && btn_next.off('mousedown', this[`_handleNext${occ}`]);
                        this[`_handleNext${occ}`] = btn_next.on('mousedown', this.$functions.handleNext);
                    }

                    if (occ === '06') {
                        const
                            {btn_submit, occ_response} = _this_frame,
                            {challenge_id} = data;

                        if (this.inArray(profile_ukg, challenge_id)) {
                            this.gotoAndStopFrame(occ_response, 1);
                        } else if (this.inArray(profile_hcm, challenge_id)) {
                            this.gotoAndStopFrame(occ_response, 2);
                        }

                        this._handleSubmit && btn_submit.off('mousedown', this._handleSubmit);
                        this._handleSubmit = btn_submit.on('mousedown', this.$functions.handleSubmit);
                    }
                } else {
                    const
                        {btn_back, occ_response} = _this_frame,
                        {challenge_id} = data;

                    if (this.inArray(profile_ukg, challenge_id)) {
                        this.gotoAndStopFrame(occ_response, 1);
                    } else if (this.inArray(profile_hcm, challenge_id)) {
                        this.gotoAndStopFrame(occ_response, 2);
                    }

                    this._handleBack && btn_back.off('mousedown', this._handleBack);
                    this._handleBack = btn_back.on('mousedown', this.$functions.handleBack);
                }
            }
        });
    };

    /**
     *
     */
    initQuiz = () => {
        const {btn_start, occ_disclaimer: {occ_modal: {btn_close, btn_next}}} = this.getFrame();

        this._handleStart && btn_start.off('mousedown', this._handleStart);
        this._handleStart = btn_start.on('mousedown', this.$functions.handleStart);

        this._handleClose && btn_close.off('mousedown', this._handleClose);
        this._handleClose = btn_close.on('mousedown', this.$functions.handleClose);

        this._handleNext && btn_next.off('mousedown', this._handleNext);
        this._handleNext = btn_next.on('mousedown', this.$functions.handleNext);

        this.startQuiz();
    };
}

/**
 *
 * @type {{}}
 */
StageQuiz.propTypes = {
    profile_challenge: PropTypes.array,
    option_position: PropTypes.array
};

/**
 *
 * @type {{}}
 */
StageQuiz.defaultProps = {
    profile_ukg: [11, 12, 13],
    profile_hcm: [14, 15, 16],
    option_position: [
        // {
        //     text: 'Select...',
        //     value: null,
        //     selected: true
        // },
        {
            text: 'Analista',
            value: 2
        },
        {
            text: 'Especialista',
            value: 3
        },
        {
            text: 'Consultor',
            value: 4
        },
        {
            text: 'Coordenador',
            value: 5
        },
        {
            text: 'Gerente',
            value: 6
        },
        {
            text: 'Diretor',
            value: 7
        },
        {
            text: 'Outros',
            value: 1
        }
    ]
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(StageQuiz, {className: 'StageQuiz'});
